import {createAction} from '@reduxjs/toolkit';

const clearState = createAction('clearState');

export {clearState};